import React from 'react'
import BkFlowReservationPropertyPoliciesModal from './BkFlowReservationPropertyPoliciesModal'
import dateFormats from '../../../../utilities/dates/dateFormats'
import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../utilities/currency/formatPrice'
import {formatRoundPrice} from '../../../../utilities/currency/formatPrice'

import moment from 'moment'
import _ from 'lodash'

const BkFlowReservationPropertyCard = ({ configData, hotelLabels, isTaxInclusiveProperty, policiesModalEvent, policiesModalVisible, reservation }) => {
  const properties = _.get(configData, 'hotel.options.properties', [])
  const hotelCode = _.get(reservation, 'roomStays[0].basicPropertyInfo.hotelCode')
  const property = properties.filter(property => property.hotelCode === hotelCode)
  const propertyLogo = _.get(reservation, 'roomStays[0].basicPropertyInfo.viewExtensions.image.path')
  const propertyName = _.get(reservation, 'roomStays[0].basicPropertyInfo.hotelName')
  const reservationItinerary = _.get(reservation, 'id', '--')
  const address = _.get(property, '[0].address')
  let mapLink = null

  if (
    propertyName &&
    address &&
    address.addressLine
  ) {
    mapLink = `https://www.google.com/maps/search/?api=1&query=${propertyName}%20${address.addressLine}`
  }

  const guests = _.get(reservation, 'roomStays[0].guestCounts', '')
  const arrival = _.get(reservation, 'roomStays[0].timeSpan.start')
  const departure = _.get(reservation, 'roomStays[0].timeSpan.end')
  const roomTypeName = _.get(reservation, 'roomStays[0].roomTypes[0].roomDescription.name', '--')
  let roomRatePrice = _.get(reservation, 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountBeforeTax')
  const currencyCode = _.get(reservation, 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].base.currencyCode')
  const currencySymbol = getCurrencySymbol(currencyCode)

  let adults = null
  let children = null

  for (const guestKey in guests) {
    const currentGuest = guests[guestKey]

    if (currentGuest.ageQualifyingCode === '10') {
      adults = _.get(currentGuest, 'count', 0)
    } else if (currentGuest.ageQualifyingCode === '8') {
      children = _.get(currentGuest, 'count', 0)
    }
  }

  let reservationSubtotal = _.get(reservation, 'roomStays[0].total.amountBeforeTax', '--')
  const feesTotal = _.get(reservation, 'roomStays[0].total.viewExtensions.fees.amount', '--')
  const taxesTotal = _.get(reservation, 'roomStays[0].total.taxes.amount', '--')
  const discount = _.get(reservation, 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].discount.amountAfterTax', '--')
  const reservationTotal = _.get(reservation, 'roomStays[0].total.amountAfterTax', '--')

  const cancelPolicies = _.get(reservation , 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].cancelPolicies')
  const paymentPolicies = _.get(reservation , 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].paymentPolicies')


  if (isTaxInclusiveProperty) {
    roomRatePrice = _.get(reservation, 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].total.amountAfterTax')
    reservationSubtotal = _.get(reservation, 'roomStays[0].total.amountAfterTax', '--')
  }
  return (
    <div className="bk-flow-confirmation__reservation-property-card">
      <h2>{hotelLabels.bookingSummary ? hotelLabels.bookingSummary : 'Booking Summary'}</h2>

      <div className="bk-flow-confirmation__reservation-property-card-content">
        <div className="bk-flow-confirmation__reservation-property-card-crs-number">
          <h5>{hotelLabels.orderConfirmation ? hotelLabels.orderConfirmation : 'Order Confirmation'}</h5>
          <h2>{reservationItinerary}</h2>
        </div>

        <div className="bk-flow-confirmation__reservation-property-card-location">
          {propertyLogo &&
            <div className="location-brand">
              <img src={propertyLogo} alt={propertyName}/>
            </div>
          }

          <div className="location-address">
            {propertyName && <h6 className="property-name">{propertyName}</h6>}

            <p className="property-address">
              {address && address.addressLine && address.addressLine + ', '}
              {address && address.postalCode && address.postalCode + ' '}
              {address && address.cityName && address.cityName}
            </p>
            {mapLink && <a href={mapLink} target="_blank" rel="noopener noreferrer">{hotelLabels.viewOnMap ? hotelLabels.viewOnMap : 'View On Map'}</a>}
          </div>
        </div>

        <div className="bk-flow-confirmation__reservation-property-card-dates">
          <p className="u-remove-margin">
            {moment(arrival).format(dateFormats.standardDate)}&nbsp;
            <i className="material-icons">east</i>&nbsp;
            {moment(departure).format(dateFormats.standardDate)}
          </p>
        </div>

        <div className="bk-flow-confirmation__reservation-property-card-room">
          <p className="property-room-name">
            <span>{roomTypeName}</span>
            <span>
              <span className="currency-symbol">&nbsp;{currencySymbol}</span>
              <span className="currency-price">{formatPrice(roomRatePrice, 2, false)}</span>
              <span className="currency-code">&nbsp;{currencyCode}</span>
            </span>
          </p>
          <p className="property-guests">
            {adults}&nbsp;{Number(children) === 1 ? hotelLabels.adult ? hotelLabels.adult : 'Adult' : hotelLabels.adults ? hotelLabels.adults : 'Adults'}&nbsp;|&nbsp;
            {children}&nbsp;{Number(children) === 1 ? hotelLabels.child ? hotelLabels.child : 'Child' : hotelLabels.children ? hotelLabels.children : 'Children'}
          </p>
        </div>

        <div className="bk-flow-confirmation__reservation-property-card-price-details">
          <p className="reservation-subtotal u-font-small">
            <span>{hotelLabels.roomTotal ? hotelLabels.roomTotal : 'Room Total'}</span>
            <span>
              <span className="currency-symbol">&nbsp;{currencySymbol}</span>
              <span className="currency-price">{formatPrice(reservationSubtotal, 2, false)}</span>
              <span className="currency-code">&nbsp;{currencyCode}</span>
            </span>
          </p>

          <p className="reservation-taxes u-font-small">
            <span>{hotelLabels.taxes ? hotelLabels.taxes : 'Taxes'}</span>
            <span>
              <span className="currency-symbol">&nbsp;{currencySymbol}</span>
              <span className="currency-price">{formatRoundPrice(taxesTotal, 2, false)}</span>
              <span className="currency-code">&nbsp;{currencyCode}</span>
            </span>
          </p>

          <p className="reservation-fees u-font-small">
            <span>{hotelLabels.fees ? hotelLabels.fees : 'Fees'}</span>
            <span>
              <span className="currency-symbol">&nbsp;{currencySymbol}</span>
              <span className="currency-price">{formatPrice(feesTotal, 2, false)}</span>
              <span className="currency-code">&nbsp;{currencyCode}</span>
            </span>
          </p>

          <p className="reservation-discount u-font-small">
            <span>{hotelLabels.discount ? hotelLabels.discount : 'Discount'}</span>
            <span>
              <span className="currency-symbol">&nbsp;{currencySymbol}</span>
              <span className="currency-price">{formatPrice(discount, 2, false)}</span>
              <span className="currency-code">&nbsp;{currencyCode}</span>
            </span>
          </p>
        </div>

        <div className="bk-flow-confirmation__reservation-property-card-price-total">
          <p className="reservation-total">
            <span className="total-price">{hotelLabels.total ? hotelLabels.total : 'Total'}</span>
            <span
              className="u-font-small">{hotelLabels.includingTaxesFees ? hotelLabels.includingTaxesFees : 'Including Taxes & Fees'}</span>
          </p>
          <p>
            <span className="currency-symbol">&nbsp;{currencySymbol}</span>
            <span className="currency-price">{formatPrice(reservationTotal, 2, false)}</span>
            <span className="currency-code">&nbsp;{currencyCode}</span>
          </p>
        </div>
      </div>

      {(cancelPolicies || paymentPolicies) &&
        <BkFlowReservationPropertyPoliciesModal
          cancelPolicies={cancelPolicies}
          hotelLabels={hotelLabels}
          policiesModalEvent={policiesModalEvent}
          policiesModalVisible={policiesModalVisible}
          paymentPolicies={paymentPolicies}
          roomTypeName={roomTypeName}
        />
      }
    </div>
  )
}

export default BkFlowReservationPropertyCard



// WEBPACK FOOTER //
// ./src/components/confirmation/elements/condensed/BkFlowReservationPropertyCard.js